import {exists, t} from 'i18next';

export default class I18nError extends Error {
  getMessage(): string {
    const key = this.message;
    const hasKey = exists(key);
    return hasKey ? t(key) : t('common-strings.unknown-server-error');
  }
}
